import { ApiGetRequest } from 'types';

export enum EecsCancellationBeneficiaryType {
  END_CONSUMER = 'END_CONSUMER',
  ENERGY_SUPPLIER = 'ENERGY_SUPPLIER',
}

export enum EecsCancellationUsageCategory {
  SUPPORT = 'SUPPORT',
  DISCLOSURE = 'DISCLOSURE',
  OTHER = 'OTHER',
}

export enum EecsCancellationModals {
  ADD = 'add',
  DETAILS = 'details',
}

export interface IEecsCancellationModal {
  type: EecsCancellationModals;
}

export interface IEecsCancellationContents {
  type_of_installation_code: string;
  energy_source_code: string;
  volume: number;
}

export interface IEecsCancellation {
  id: string;
  consumption_country_name: string;
  beneficiary_location: string;
  beneficiary_name: string;
  beneficiary_business_id: string | null;
  beneficiary_type: EecsCancellationBeneficiaryType;
  usage_category: EecsCancellationUsageCategory;
  consumption_period_start: string;
  consumption_period_end: string;
  comment: string | null;
  certificates_contents: IEecsCancellationContents[];
  download_statement_url: string;
  created_at: string;
}

export interface FetchEecsCancellationsPayload extends ApiGetRequest {
  filter_by_creation_start_date?: string | null;
  filter_by_creation_end_date?: string | null;
  filter_by_energy_source?: string | null;
  filter_by_type_of_installation?: string | null;
  filter_by_registry?: string | null;

  order_by_beneficiary_name?: 'asc' | 'desc';
  order_by_contents_volume?: 'asc' | 'desc';
  order_by_comment?: 'asc' | 'desc';
}

export interface AddEecsCancellationPayload {
  consumption_country_name: string;
  consumption_country_code: string;
  beneficiary_location: string;
  beneficiary_name: string;
  beneficiary_business_id: string | null;
  beneficiary_type: EecsCancellationBeneficiaryType;
  usage_category: EecsCancellationUsageCategory;
  consumption_period_start: string;
  consumption_period_end: string;
  comment: string | null;
  certificates_contents: {
    group_id: string;
    volume: number;
  }[];
}
